// extracted by mini-css-extract-plugin
export default {"Comment":"styles_Comment__aqira","ResetButton":"styles_ResetButton__t2hIR"};